import $ from 'jquery';

const SLIDE_TIME =  "fast";

export function initMenuBrs() {
  $('.js-menu-brs_toggle').click(function() {
    toggleBtn(this);

    return false;
  });
}

function toggleBtn(button) {
  $(button).next()
    .stop(true)
    .slideToggle(SLIDE_TIME);

    $(button).children("svg").toggleClass("is-up");
}


// WEBPACK FOOTER //
// ./src/components/menu-brs/menuBrs.js